"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdPlacement = void 0;
var xandr_1 = require("./xandr");
exports.AdPlacement = Object.fromEntries(Object.entries(xandr_1.PlacementId).map(function (_a) {
    var key = _a[0], value = _a[1];
    return [
        key,
        {
            id: value,
            containerId: "".concat(value, "--container"),
            slot: "".concat(value, "--slot")
        }
    ];
}));
